import React from 'react';
import { Section } from '@carbon/react';
import PageContainer from '../components/PageContainer';
import EmployeesTable from '../components/EmployeesTable';

const InactiveEmployees = () => (
  <PageContainer>
    <Section style={{
      padding: 0,
      maxWidth: '100%',
      margin: 0,
      height: '100%'
    }}>
      {/* Tabela zaposlenih - prikazuje samo deaktivirane ("bivše") zaposlene.
          `inactiveOnly` prebacuje fetch na GET /api/Employee/inactive. */}
      <div style={{
        padding: 0,
        height: '100%'
      }}>
        <EmployeesTable inactiveOnly />
      </div>
    </Section>
  </PageContainer>
);

export default InactiveEmployees;
